import {
  QuoteSubcontracting,
  SubcontractExpenses,
  SubcontractInvoice,
  SubcontractReview,
  SubcontractorDirectory,
  SubcontractorPage,
  Supplier,
  SupplierList,
  type AttachSubcontractExpenseBody,
  type PutQuoteSubcontractingBody,
  type SubcontractorClassification,
} from '@cockpit/shared';
import { request } from './client';

const id = (value: string) => encodeURIComponent(value);

/**
 * Lot AY « Sous-traitance », à part de `api/index.ts` : sous-traitance d'un devis, fournisseurs, fiche sous-traitant,
 * dépenses des sous-traitants, reprise. Écritures internes, réservées au réseau.
 */
export const subcontractingApi = {
  quote: (quoteId: string) =>
    request('GET', `/api/quotes/${id(quoteId)}/subcontracting`, { schema: QuoteSubcontracting }),
  saveQuote: (quoteId: string, body: PutQuoteSubcontractingBody) =>
    request('PUT', `/api/quotes/${id(quoteId)}/subcontracting`, { body, schema: QuoteSubcontracting }),
  setDueDate: (quoteId: string, date: string | null) =>
    request('PUT', `/api/quotes/${id(quoteId)}/subcontracting/due-date`, {
      body: { date },
      schema: QuoteSubcontracting,
    }),
  clearQuote: (quoteId: string) =>
    request('DELETE', `/api/quotes/${id(quoteId)}/subcontracting`, { schema: QuoteSubcontracting }),
  suppliers: () => request('GET', '/api/suppliers', { schema: SupplierList }),
  classify: (supplierId: string, classification: SubcontractorClassification) =>
    request('PUT', `/api/admin/suppliers/${id(supplierId)}/subcontractor`, {
      body: { classification },
      schema: Supplier,
    }),
  directory: () => request('GET', '/api/subcontractors/directory', { schema: SubcontractorDirectory }),
  page: (supplierId: string) =>
    request('GET', `/api/subcontractors/${id(supplierId)}`, { schema: SubcontractorPage }),
  expenses: () => request('GET', '/api/subcontracting/expenses', { schema: SubcontractExpenses }),
  attachExpense: (expenseId: string, body: AttachSubcontractExpenseBody) =>
    request('PUT', `/api/expenses/${id(expenseId)}/subcontract`, { body, schema: SubcontractInvoice }),
  review: () => request('GET', '/api/subcontracting/review', { schema: SubcontractReview }),
};
